import React, {FC} from "react";
import useTranslate from "../../modules/core/languages/hooks/useTranslate";
import BookingItem from "./BookingItem";
import ApiBooking from "../../modules/booking/types/ApiBooking";
import {Link} from "react-router-dom";
import Loader from "../../modules/ui/shared/Loader/Loader";
import BookingMeSearchForm from "../../modules/booking/components/MeSearchForm/BookingMeSearchForm";
import {useBookingMeSearchData} from "../../modules/booking/hooks/useBookingMeSearchData";
import {Alert} from "../../modules/ui/shared/Alert/Alert";

export interface CheckoutItemListProps {
}

const BookingList: FC<CheckoutItemListProps> = () => {
    const t = useTranslate();
    const {data: bookings, loading, fetchData} = useBookingMeSearchData();

    const renderItem = (data: ApiBooking) => {
        return (
            <div
                className="relative w-full flex flex-col sm:rounded-2xl lg:border border-neutral-200 dark:border-neutral-700 px-0 sm:p-2 xl:p-2 mb-2 hover:shadow-xl transition-shadow will-change-transform"
                key={data.id}
            >
                <Link to={`/book-ok/${data.internalId}`} className="absolute inset-0"/>
                <BookingItem item={data}/>
            </div>
        )
    };

    return (
        <div
            className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
            <h2 className="text-3xl lg:text-4xl font-semibold">
                {t("mainNav.bookings")}
            </h2>
            <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
            <BookingMeSearchForm onSearch={fetchData} loading={loading} bookings={bookings}/>
            <div>
                {loading && <Loader centerHorizontally/>}
                {!loading && bookings.length === 0 && <Alert type="info" closable={false}>{t("booking.noBookings")}</Alert>}
                {!loading && bookings.length > 0 && bookings.map((booking) => renderItem(booking))}
            </div>
        </div>
    );
}

export default BookingList;
